<template>
  <v-container fluid>
    <!--HEADER-->
    <v-app-bar color="#3F9D2A" flat app dense height="40px" dark>
      <v-btn icon :to="{ name: 'rda' }">
        <v-icon>mdi-home-outline</v-icon>
      </v-btn>
      <v-toolbar-title>Números Importantes</v-toolbar-title>      
    </v-app-bar>
    <v-card class="pa-2 py-1" > 
      <v-row class="ma-2 mx-0 mt-0">
            <v-chip label small dark v-for="(itemtelefono, i) in itemTelefonos" :key="`${i}-${itemtelefono.id}`" color="#3F9D2A" class="ma-1 pr-2" :href="itemtelefono.hr">
                   <v-avatar left tile>
                      <v-icon small>{{itemtelefono.icono}}</v-icon>
                    </v-avatar>
                            {{itemtelefono.texto}} 
                    <v-avatar tile  >
                      <v-icon small >{{itemtelefono.icono2}}</v-icon>
                    </v-avatar>
                              {{itemtelefono.texto2}}
                    <template v-if="itemtelefono.texto3">  
                    <v-avatar tile  >
                      <v-icon small >{{itemtelefono.icono3}}</v-icon>
                    </v-avatar>
                              {{itemtelefono.texto3}}
                    </template>
                    
          </v-chip>
      </v-row>      
    <v-divider class="ma-1"></v-divider>    
          <v-row class="caption ma-0 pa-1 "  >
            Por cobertura de emergencias de área protegida dentro del complejo comunicarse a Recepción       
          </v-row>
        
      
    </v-card>    
  </v-container>
</template>
<script>
//import axios from 'axios'
export default {
  data() {
    return {
      itemTelefonos: [
        { id:"1",texto: "Recepción", icono: "mdi-room-service-outline", texto2:"9 | 200 | 130",icono2:"mdi-phone",texto3:"549 115111 7247",icono3:"mdi-whatsapp",hr:"https://wa.me/5491151117247?text=" },
         {id:"2", texto: "Restaurante", icono: "mdi-silverware", texto2:"128",icono2:"mdi-phone" },       
        {id:"3", texto: "Rincón de los niños", icono: "mdi-baby-face-outline", texto2:"124",icono2:"mdi-phone" },
        {id:"4", texto: "Piscina", icono: "mdi-swim", texto2:"123",icono2:"mdi-phone" },
        {id:"5", texto: "Lavadero", icono: "mdi-washing-machine", texto2:"116",icono2:"mdi-phone" },
       {id:"6", texto: "RR.PP", icono: "mdi-account-multiple", texto2:"146 | 151",icono2:"mdi-phone" },
       {id:"7", texto: "GYM", icono: "mdi-dumbbell", texto2:"119",icono2:"mdi-phone" }
      ]
   
    }
  },
  methods:{
            abrir(){
                    alert("hola")
            }
  }
}
</script>
